<template>
  <holding-tank-layout-wide>
    <!-- <img v-if="brokerLogo" class="h-11 w-auto mx-auto md:hidden my-6" :src="brokerLogo" alt="broker logo" /> -->
    <h1 class="header-text leading-tight">Equipment Verification Required</h1>
    <p class="mt-4 text-sm text-dark-gray">
      We need to verify your equipment in order to fully establish your identity
      to parties with whom you choose to connect. This helps us detect fraud and
      protect your account from identity theft.
    </p>
    <p class="mb-4 mt-5 text-dark-gray">Please select your ELD provider.</p>
    <div class="mb-6 flex w-full items-center justify-start md:mb-8">
      <div class="relative w-full">
        <input
          v-model="searchText"
          type="text"
          placeholder="Search ELD Providers..."
          class="w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
          style="padding-left: 40px; padding-right: 40px"
        />
        <div
          class="absolute left-3 top-0 flex h-full items-center justify-center"
        >
          <div class="cursor-pointer text-gray-over-dark">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="h-6 w-6"
            >
              <path
                fill-rule="evenodd"
                d="M10.5 3.75a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM2.25 10.5a8.25 8.25 0 1114.59 5.28l4.69 4.69a.75.75 0 11-1.06 1.06l-4.69-4.69A8.25 8.25 0 012.25 10.5z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
        <div
          class="absolute right-3 top-0 flex h-full items-center justify-center"
        >
          <div
            v-if="searchText?.length > 0"
            class="cursor-pointer text-gray-over-dark"
            @click="searchText = ''"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              class="h-6 w-6"
            >
              <path
                fill-rule="evenodd"
                d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-8 min-h-50">
      <div
        v-if="eldProvidersFilteredAndLimited?.length > 0"
        class="grid grid-cols-2 gap-4"
      >
        <round-radio-button-eld
          v-for="item in eldProvidersFilteredAndLimited"
          :key="`eld-${item?.id}`"
          :item="item"
          :handle-click="($event) => handleSelectRadio($event, item?.id)"
          name="eld_provider"
          :value="item?.id"
          :show="true"
          :checked="selectedItem == item?.id"
          :search-text="searchText"
        />
        <div
          v-if="additionalELDs > 0"
          class="rrbv-wrapper flex flex-col items-center justify-center rounded-md p-0"
        >
          <span v-if="additionalELDs > 1">{{ additionalELDs }} more ELDs</span>
          <span v-else>{{ additionalELDs }} more ELD</span>
        </div>
        <div
          v-if="searchText?.length > 0 && !(searchResultCount > 0)"
          class="col-span-2 flex h-25 items-center justify-center rounded-lg bg-off-white text-body-color"
        >
          <p class="text-sm">No matching ELD providers found</p>
        </div>
      </div>
      <div
        v-else
        class="mb-8 grid grid-cols-2 gap-4"
      >
        <div
          v-for="index in 8"
          :key="`loading-eld-${index}`"
          class="loading-gradient flex w-full flex-col items-center justify-center rounded-md border border-light-gray p-0"
          style="height: 98px"
        />
      </div>
    </div>
    <button-main
      ref="continuebtn"
      class="mb-4 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2"
      :disabled="!selectedItem"
      @click="handleSubmit"
    >
      Continue
    </button-main>
    <button-main
      v-if="showELDExemptButton"
      variant="secondary"
      class="mb-4"
      @click="handleExempt"
    >
      I'm not legally required to have an ELD
    </button-main>
    <button-main
      variant="secondary"
      @click="handleEldNotListed"
    >
      My ELD is not listed
    </button-main>
  </holding-tank-layout-wide>
</template>

<script>
import Button from '../Button.vue';
// import Layout from "../layouts/HoldingTankLayout.vue";
import HoldingTankLayoutWide from '@/components/layouts/HoldingTankLayoutWide.vue';
import RoundRadioButtonEld from '@/components/RoundRadioButtonEld.vue';

export default {
  name: 'HeldForFailedPhysicalLocationActivityVerification',
  components: {
    'button-main': Button,
    // Layout,
    HoldingTankLayoutWide,
    RoundRadioButtonEld,
  },
  props: {
    companyType: String,
    companyName: String,
    loading: Boolean,
    failedRules: {
      type: Array,
      default: () => [],
    },
    uniqueFailedRules: Array,
    incompleteRules: {
      type: Array,
      default: () => [],
    },
    uniqueIncompleteRules: Array,
    totalRules: Number,
    rulesSyntax: Object,
    supportEmail: String,
    brokerLogo: String,
  },
  data() {
    return {
      isLoading: false,
      selectedItem: '',
      showRuleLabels: false,
      syntaxData: false,
      searchText: '',
      // eldProviders: [
      //   { is_type: 'motive' },
      //   { is_type: 'samsara' },
      //   { is_type: 'omnitracsvlv' },
      //   { is_type: 'bigroad' },
      //   { is_type: 'geotab' },
      //   { is_type: 'peoplenet' },
      //   { is_type: 'verizon_reveal' },
      //   { is_type: 'eroad' },
      //   { is_type: 'gpsinsight' },
      //   { is_type: 'vistracks' },
      //   { is_type: 'omnitracs' },
      //   { is_type: 'rand' },
      // ]
    };
  },
  computed: {
    requestedCarrierId() {
      return this.$store.state.users?.currentUser?.requested_carrier_id;
    },
    showELDExemptButton() {
      if (process.env.HIDE_ELD_EXEMPT_BUTTON > 0) {
        return false;
      }
      return this.$store.state.carriers.carrierData
        ?.is_eld_exemption_submission_allowed;
    },
    eldProviders() {
      if (this.$store.state.onboardingPacket?.eld_providers?.length > 0) {
        let all = [
          ...(this.$store.state.onboardingPacket?.eld_providers ?? []),
        ];
        return all.filter((el) => el?.eld_type !== 'eld_exempt');
        // all = all.filter(el => el?.eld_type !== 'eld_exempt');
        // return all.sort(function(a, b) {
        //   return a.id - b.id;
        // });
      }
      return [];
    },
    eldProvidersFiltered() {
      let filtered = this.eldProviders;
      if (this.searchText.length > 0) {
        let regex = new RegExp(this.searchText, 'i');
        filtered = this.eldProviders.filter((eldProvider) =>
          regex.test(eldProvider.name)
        );
      }
      return filtered;
    },
    eldProvidersFilteredAndLimited() {
      return this.eldProvidersFiltered?.slice(0, 7);
    },
    additionalELDs() {
      return (
        this.eldProvidersFiltered.length -
        this.eldProvidersFilteredAndLimited.length
      );
    },
    eldProviderNames() {
      return this.eldProviders.map((el) => el?.name);
    },
    searchResultCount() {
      const searchText = this.searchText?.toLowerCase()?.trim();
      const eldNames = [...(this.eldProviderNames ?? [])];
      if (searchText?.length > 0) {
        const matchingNames = eldNames.filter((name) =>
          name.toLowerCase().includes(searchText)
        );
        const uniqueMatchingNames = new Set(matchingNames);
        return uniqueMatchingNames?.size;
      } else {
        return false;
      }
    },
    eldExempt() {
      if (
        this.$store.state.onboardingPacket?.eld_providers?.length > 0 &&
        this.showELDExemptButton
      ) {
        return this.$store.state.onboardingPacket?.eld_providers?.find(
          (el) => el?.eld_type === 'eld_exempt'
        );
      }
      return null;
    },
    totalFailedRules() {
      return this.uniqueFailedRules.length;
    },
    broker() {
      return this.$store.state.company.company;
    },
    hasFailedPhysicalLocationActivityVerification() {
      const eldSensitiveRuleSets =
        this.$store.state.onboardingPacket.eld_sensitive_rule_sets;
      let returnVal = false;
      let self = this;
      eldSensitiveRuleSets.forEach((rule_set) => {
        if (self.uniqueFailedRules?.includes(rule_set)) {
          returnVal = true;
        }
      });

      return returnVal;
    },
    hasFailedScheduledAuto() {
      return this.uniqueFailedRules?.includes(
        'has_vin_if_auto_policy_is_scheduled_autos'
      )
        ? true
        : false;
    },
    hasFailedSafetyRating() {
      return this.uniqueFailedRules?.includes(
        'safety_rating_satisfactory_or_unrated'
      )
        ? true
        : false;
    },
    latest_carrier_eld_provider() {
      if (this.$store.state.onboardingPacket?.latest_carrier_eld_provider) {
        return this.$store.state.onboardingPacket?.latest_carrier_eld_provider;
      } else if (
        this.$store.state.carriers?.carrierData?.latest_carrier_eld_provider
      ) {
        return this.$store.state.carriers?.carrierData
          ?.latest_carrier_eld_provider;
      }
      return null;
    },
  },
  watch: {
    failedRules: {
      deep: true,
      handler() {
        let self = this;
        let rVal = {};
        self.failedRules.forEach(async function (el) {
          let id = el?.id;
          let syntax = await self.$store.dispatch(
            'carriers/getRulesSyntaxByClassificationId',
            id
          );
          rVal[id] = syntax;
        });
        self.syntaxData = rVal;
        if (typeof self.syntaxData === 'object') {
          setTimeout(function () {
            self.showRuleLabels = true;
          }, 300);
        }
      },
      immediate: true,
    },
    latest_carrier_eld_provider: {
      handler(val) {
        let self = this;
        if (val?.connect_channel?.id > 0 && self.selectedItem === '') {
          self.selectedItem = val?.connect_channel?.id;
        }
      },
      immediate: true,
    },
  },
  created() {
    if (this.$store.state.integrations?.updateEld) {
      this.$router.push({
        name: 'Carrier Connect ELD',
        params: {
          id: this.$route.params.id,
        },
      });
    }
    if (this.eldProviders?.length < 1) {
      this.$store.dispatch('onboardingPacket/getEldProviders');
    }
  },
  methods: {
    async handleEldNotListed() {
      if (this.eldExempt?.id) {
        await this.$store.dispatch(
          'onboardingPacket/createCarrierEldProvider',
          this.eldExempt?.id
        );
      }
      this.$router.push({
        name: 'Carrier ELD Provider Not Listed',
        params: {
          id: this.$route.params.id,
        },
      });
    },
    handleSelectRadio(e, value) {
      if (e?.target?.name) {
        this.selectedItem = value;
        this.$refs['continuebtn'].$el.nextElementSibling.scrollIntoView({
          behavior: 'smooth',
        });
        setTimeout(
          function () {
            this.$refs['continuebtn'].$el.nextElementSibling.focus();
          }.bind(this),
          500
        );
      }
    },
    async handleExempt() {
      if (this.eldExempt?.id) {
        await this.$store.dispatch(
          'onboardingPacket/createCarrierEldProvider',
          this.eldExempt?.id
        );
      }
      this.$router.push({
        name: 'Carrier Connect ELD',
        params: {
          id: this.$route.params.id,
        },
      });
    },
    async handleSubmit() {
      if (this.selectedItem) {
        await this.$store.dispatch(
          'onboardingPacket/createCarrierEldProvider',
          this.selectedItem
        );
      }
      this.$router.push({
        name: 'Carrier Connect ELD',
        params: {
          id: this.$route.params.id,
        },
      });
    },
  },
};
</script>
<style scoped>
.header-text {
  font-size: 26px;
}

.text-link {
  color: #e7b812;
}

.link-icon {
  position: relative;
  bottom: 1px;
}

.fail-status {
  padding: 4px 8px;
  background: #fff0e3;
  border-radius: 20px;
  font-size: 10px;
  width: 34px;
  height: 24px;
}
</style>
